import React from 'react';
import { useSelector } from 'react-redux';
import { Link, useNavigate } from 'react-router-dom';
import { Menu, MenuItem } from 'carbon-react/lib/components/menu';
import Box from 'carbon-react/lib/components/box';
import { useFlags } from 'launchdarkly-react-client-sdk';

import {
  StoreState,
  getFullNameSelector,
  LOGOUT_ROUTE,
  getIsSxpManagedSelector,
  getIsSageIdSelector
} from '@futrli/auth';
import { FormattedMessage } from '@futrli/localisation';
import { ROUTES } from '@futrli/shared-services';

export const ProfileMenu = () => {
  const navigate = useNavigate();

  const flags = useFlags();

  const fullName = useSelector((store: StoreState) => {
    const { authReducers } = store;
    return getFullNameSelector(authReducers);
  });

  const isSxpManaged = useSelector((store: StoreState) => {
    const { authReducers } = store;
    return getIsSxpManagedSelector(authReducers);
  });

  const isSageIdUser = useSelector((store: StoreState) => {
    const { authReducers } = store;
    return getIsSageIdSelector(authReducers);
  });

  const handleMyProfileClick = () => {
    navigate(ROUTES.MY_PROFILE);
  };

  const showMyProfile = (isSageIdUser && flags.switchLocale) || (!isSageIdUser && !isSxpManaged);

  return (
    <Box>
      <Menu menuType="black">
        <MenuItem submenu={fullName} maxWidth="350px">
          {showMyProfile && (
            <div>
              <MenuItem onClick={handleMyProfileClick}>
                <FormattedMessage id="common.my_profile_2" defaultMessage="My profile" />
              </MenuItem>
            </div>
          )}
          <div>
            <MenuItem>
              <Link to={LOGOUT_ROUTE}>
                <FormattedMessage id="common.log_out" defaultMessage="Log out" />
              </Link>
            </MenuItem>
          </div>
        </MenuItem>
      </Menu>
    </Box>
  );
};
